// we don't want to import node packages so make our own assert
exports.assert = function (condition, message) {
  if (!condition) {
    throw new Error(message);
  }
};
